export const meta = {
  title: 'Limbiks - AI Flashcard Generator',
  description: `Upload pdfs, presentations, notes, images, and more. Limbiks creates a comprehensive deck of flashcards in seconds`
};
